export default __webpack_public_path__ + "static/media/listor2.12bd01ca.png";